export default {
  fonts: {
    body: 'Poppins, sans-serif'
  }
};
